export default [
  {
    key: 'id',
    type: 'id',
    visibility: ['view'],
  },
  {
    key: 'invoice_number',
    label: 'No. Invoice',
  },
  {
    key: 'buyer',
    label: 'Pembeli',
    type: 'profile',
    image: 'buyer_image',
    visibility: ['view'],
  },
  {
    key: 'brands',
    label: 'Brand',
    type: 'profiles',
    limit: 3,
    visibility: ['view'],
  },
  {
    key: 'total_price',
    label: 'Total Produk',
    type: 'rupiah',
    prefix: 'Rp ',
  },
  {
    key: 'shipping_cost',
    label: 'Biaya Pengiriman',
    type: 'rupiah',
    prefix: 'Rp ',
  },
  {
    key: 'product_discount',
    label: 'Potongan Produk',
    type: 'rupiah',
    prefix: 'Rp ',
  },
  {
    key: 'shipping_discount',
    label: 'Potongan Pengiriman',
    type: 'rupiah',
    prefix: 'Rp ',
  },
  {
    key: 'total_shopping',
    label: 'Total Tagihan',
    type: 'rupiah',
    prefix: 'Rp ',
  },
  {
    key: 'status',
    label: 'Status',
    type: 'badge',
    map: {
      used: 'success',
      cancelled: 'danger',
      pending: 'warning',
    },
    filter: {
      key: 'status',
      type: 'select',
      label: 'Status',
      options: [
        { value: 'used', text: 'Dipakai' },
        { value: 'canceled', text: 'Dibatalkan' },
        { value: 'pending', text: 'Pending' },
      ],
    },
  },
]
